import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class SupplierService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getSupplier(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/supplier/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }
  public getSupplierReplace(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/supplier/?' + gridData.toString())
      .pipe(map(rsp => rsp['data']), catchError(res => this.helper.catchError(res)));
  }

  public getSupplierItem(supplierId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/supplier/' + supplierId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageSupplier(supplier, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/supplier/' + id, supplier)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/supplier/', supplier)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
  public softDeleteSupplier(id, replaceId) {
    return this.http.delete(environment.apiUrl + '/backoffice/supplier/' + id + '/replace/' + replaceId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
  public reAdd(id) {
    return this.http.put(environment.apiUrl + '/backoffice/supplier/' + id + '/reAdd', {id : id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
